import { useState } from 'react';
import type { LocationData } from '../locationData';

interface Props {
  location: LocationData;
}

export default function LocationFAQ({ location }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-green-50 text-green-700 rounded-full text-sm font-semibold mb-4">
            FAQs
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Questions About Our {location.name} Services
          </h2>
          <p className="text-lg text-gray-600">
            Common questions from {location.name} homeowners — answered.
          </p>
        </div>

        <div className="space-y-3">
          {location.faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                openIndex === i ? 'border-green-300 bg-green-50' : 'border-gray-200 bg-white'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className={`font-semibold text-base ${openIndex === i ? 'text-green-700' : 'text-gray-900'}`}>
                  {faq.question}
                </span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ml-4 transition-colors ${
                  openIndex === i ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-500'
                }`}>
                  <i className={`text-lg transition-transform duration-200 ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <p className="text-center text-gray-500 text-sm mt-8">
          Still have questions?{' '}
          <a href="tel:+16479837924" className="text-green-600 font-semibold hover:underline cursor-pointer">
            Call us at (647) 983-7924
          </a>{' '}
          or{' '}
          <a href="mailto:info@mowandsnow.co" className="text-green-600 font-semibold hover:underline cursor-pointer">
            email info@mowandsnow.co
          </a>
        </p>
      </div>
    </section>
  );
}
